import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Goods, CreateGoodsDto, UpdateGoodsDto, BulkImportGoodsResult, GoodsStatus } from '../models/goods.model';
import { apiBase } from './api-config';

@Injectable({ providedIn: 'root' })
export class GoodsService {
  private http = inject(HttpClient);
  private base = `${apiBase}/goods`;

  getAll(status?: GoodsStatus): Observable<Goods[]> {
    const params = status ? new HttpParams().set('status', status) : undefined;
    return this.http.get<Goods[]>(this.base, { params });
  }

  getById(id: number): Observable<Goods> {
    return this.http.get<Goods>(`${this.base}/${id}`);
  }

  create(dto: CreateGoodsDto): Observable<Goods> {
    return this.http.post<Goods>(this.base, dto);
  }

  update(id: number, dto: UpdateGoodsDto): Observable<Goods> {
    return this.http.put<Goods>(`${this.base}/${id}`, dto);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}`);
  }

  bulkImport(file: File): Observable<BulkImportGoodsResult> {
    const form = new FormData();
    form.append('file', file);
    return this.http.post<BulkImportGoodsResult>(`${this.base}/bulk-import`, form);
  }
}
